export const getRatingText = (score: number | string) => {
  if (score === 'N/A') return 'N/A'

  const numericScore = typeof score === 'number' ? score : Number(score)

  if (!Number.isNaN(numericScore)) {
    if (numericScore >= 8.0) return 'Excellent'
    if (numericScore >= 5.1) return 'Good'
    if (numericScore >= 4.0) return 'Average'
    return 'Poor'
  }

  const normalizedScore = typeof score === 'string' ? score.trim() : ''
  return normalizedScore || 'N/A'
}

export const getPerformanceRatingStyle = (rating: string) => {
  switch (rating) {
    case 'Excellent':
      return 'bg-[#DBFFEA80] border border-[rgba(3,150,63,0.2)] text-[#03963F]'
    case 'Good':
      return 'bg-[#FFF2DB80] border border-[rgba(240,164,34,0.2)] text-[#D48A0C]'
    case 'Average':
      return 'bg-[#F08F641F] border border-[rgba(66,133,244,0.2)] text-[#F08F64]'
    case 'Good Fit':
      return 'bg-[#DBFFEA80] border border-[rgba(3,150,63,0.2)] text-[#03963F]'
    case 'May Be':
      return 'bg-[#FFF2DB80] border border-[rgba(240,164,34,0.2)] text-[#D48A0C]'
    case 'Not Fit':
      return 'bg-[#F08F641F] border border-[rgba(66,133,244,0.2)] text-[#F08F64]'
    default:
      return 'bg-[#FFE5E780] border border-gray-200 text-[#CF0C19]'
  }
}

